import AnalyticsHelper from "../utils/analyticsHelper";
import { Trk } from "./constants";

export const handleUserSignupAnalytics = (response) => {
    AnalyticsHelper.Alias(response.subscriberid);
    AnalyticsHelper.Identify(response.subscriberid);
    AnalyticsHelper.Track(Trk.ATTR.Account.ENTRY_POINT_URL, {
        category: "account",
        action: "created",
        ENTRY_POINT_URL: response.entryPointUrl
    });

    if (typeof rdt === "function") {
        rdt("track", "SignUp");
    }
}

/**
 * Checks if the given access level matches the expected access level.
 * 
 * @param {string|number|null|undefined} level - The required access level, which can be a string (e.g., "40"), 
 *                                               a number (e.g., 40), null, or undefined.
 * @param {number} expectedLevel - The numeric value of the expected access level (e.g., UserAccessLevelType.Professional).
 * 
 * @returns {boolean} - Returns true if the `level` is valid and matches the `expectedLevel`, 
 *                      otherwise returns false. Handles cases where `level` is null, undefined, 
 *                      or a non-numeric value gracefully.
 */
export const isRequiredAccessLevelMatching = (level, expectedLevel) =>{
    const accessLevel = Number(level);
    return !isNaN(accessLevel) && accessLevel === expectedLevel;
}